export enum Namespaces {
    user = "user"
}
